import type {
  IJobAssociatedTaskSheet,
  ITaskSheetSection,
  IDocument,
  IJobAssociatedTaskSheetConfigurableBody,
  ITaskSheetBody
} from '@/interfaces'
import type { ChangeStatusType, JobType } from '@/enum'
import TaskSheetSection from '../task-sheets/TaskSheetSection'
import DocumentModel from '../DocumentModel'
import JobAssociatedTaskSheetConfigurableBody from './JobAssociatedTaskSheetConfigurableBody'
import Base from '../Base'

class JobAssociatedTaskSheet extends Base implements IJobAssociatedTaskSheet {
  taskSheetId: string

  title: string

  description: string

  type: JobType

  header: ITaskSheetSection

  bodies: ITaskSheetBody[]

  footer: ITaskSheetSection

  documents: IDocument[]

  constructor(taskSheet?: any) {
    super(taskSheet)
    this.taskSheetId = taskSheet.taskSheetId
    this.title = taskSheet?.title
    this.description = taskSheet?.description
    this.type = taskSheet?.type
    this.header = new TaskSheetSection(taskSheet?.header)
    this.bodies = taskSheet?.bodies?.map(
      (body: any) => new JobAssociatedTaskSheetConfigurableBody(body)
    )
    this.footer = new TaskSheetSection(taskSheet?.footer)
    this.documents = taskSheet?.documents?.map((document: any) => new DocumentModel(document))
  }
}

export default JobAssociatedTaskSheet
